<template>
  <div id="app">
    <!-- <site-header></site-header> -->

    <main class="app-content">
      <router-view :key="$route.fullPath"></router-view>
    </main>
  </div>
</template>

<script>
  // import SiteHeader from "@/components/site-header.vue"

  export default {
    name: "app",
    // components: { SiteHeader }
  }
</script>
